import './ModalHeader.scss';
import clsx from 'clsx';
import React, { memo, ReactNode } from 'react';
import { FormattedMessage } from 'src/migration/react-intl';
import { Button } from 'src/modules/common/components/Button';
import { Tooltip } from 'src/modules/common/components/Tooltip';
import { CrossIcon } from 'src/modules/common/icons/CrossIcon';
import { ResetIcon } from 'src/modules/common/icons/ResetIcon';

type Props = {
  danger?: boolean;
  shaded?: boolean;
  title?: ReactNode;
  label?: ReactNode;
  handleClose?: () => void;
  handleReset?: () => void;
};

export const ModalHeader = memo(({ title, label, danger, shaded, handleClose, handleReset }: Props) => (
  <div className={clsx({
    'bp-modal-header': true,
    'bp-modal-header--danger': danger,
    'bp-modal-header--shaded': shaded,
  })}
  >
    <div className="bp-modal-header__actions">
      {handleReset && (
        <Button kind="ghost" iconOnly={true} onClick={handleReset}>
          <div className="bp-modal-header__icon">
            <ResetIcon/>
          </div>
        </Button>
      )}

      {handleClose && (
        <Tooltip id="modal/close/label" value={<FormattedMessage id="modal/close/label"/>}>
          <Button kind="ghost" iconOnly={true} onClick={handleClose}>
            <div className="bp-modal-header__icon">
              <CrossIcon/>
            </div>
          </Button>
        </Tooltip>
      )}
    </div>

    <p className="bp-modal-header__label">{label}</p>

    {title ? (<p className="bp-modal-header__title">{title}</p>) : null}
  </div>
));
